import $ from "jquery";

/*
 * Workaround to fix the z-index of the logo that hovers the top-bar
 * and the floating menus in the top-bar
 */

document.addEventListener("turbolinks:load", loadTopbar);

function loadTopbar() {
  var $topbar = $(".js-topbar");
  var activeMenuClass = "has-active-menu";
  var $menuButtons = $(".js-dropdown-close-hack");

  // This is the semi-transparent overlay that blocks out the rest of the page
  // when the menu is open
  var $overlay = $('<div class="oog-topbar__overlay" />');

  $topbar.on("show.zf.dropdownMenu", function () {
    $topbar.toggleClass(activeMenuClass, true);
    $overlay.appendTo($topbar);
  });

  $topbar.on("hide.zf.dropdownMenu", function () {
    $topbar.toggleClass(activeMenuClass, false);
    $overlay.remove();
  });

  $menuButtons.on("touchend", function (event) {
    var $el = $(event.target);
    var hackClass = "is-active-hack";

    $el.toggleClass(hackClass);

    setTimeout(function () {
      if ($el.parent("li").hasClass("is-active") && !$el.hasClass(hackClass)) {
        $("body").click();
      }
    }, 50);
  });

  $(window).scroll(function () {
    if ($(this).scrollTop() > 140) {
      $topbar.addClass("is-stuck");
    } else {
      $topbar.removeClass("is-stuck");
    }
  });

  /* toggle the mobile menu */
  var el = document.querySelector(".menu-toggle");
  var target = document.querySelector(".top-bar-right-nav");
  el.onclick = function () {
    target.classList.toggle("is-active");
    el.classList.toggle("is-active");
  };

  // Close mobile menu when resizing above 1072px
  function closeMobileMenuOnResize() {
    const toggleEl = document.querySelector(".menu-toggle");
    const navEl = document.querySelector(".top-bar-right-nav");
    if (window.innerWidth > 1072) {
      if (navEl) navEl.classList.remove("is-active");
      if (toggleEl) toggleEl.classList.remove("is-active");
    }
  }

  window.addEventListener("resize", closeMobileMenuOnResize);
  // Ensure correct state on load
  closeMobileMenuOnResize();

  /* toggle submenus menu */
  const submenuParents = document.getElementsByClassName(
    "menu-item-has-children",
  );
  if (submenuParents.length > 0) {
    for (let i = 0; i < submenuParents.length; i++) {
      const parent = submenuParents[i];
      const button = parent.querySelector("a");
      const target = parent.querySelector(".sub-menu");
      // Toggle submenu on parent click, but not when clicking submenu links
      parent.addEventListener("click", function (e) {
        // If the click is on the parent <a>, prevent default and toggle submenu
        if (e.target === button) {
          e.preventDefault();
          target.classList.toggle("is-active");
          console.log("toggle");
        }
      });

      // Close submenu when clicking outside
      document.addEventListener("click", function (elem) {
        if (!parent.contains(elem.target)) {
          target.classList.remove("is-active");
        }
      });
    }
  }
}
